import {get, patch} from "../helper/request";
import {error_manager} from "../helper/error_manager";
import {LOAD_OSD_VIEWER_CONFIG, UPDATE_OSD_VIEWER_CONFIG} from "../redux_constants/osd.viewer.config.constant";
import {UPDATE_MORPHEUS_SETTING} from "../redux_constants/morpheus.setting.constant";

export const loadOsdViewerConfig = () => dispatch =>
	get('/api/osd/viewer_config/', true)
		.then(config => dispatch({type: LOAD_OSD_VIEWER_CONFIG, config}))
		.catch(error => {
			// Mark loaded with no permissions so the gamma viewer falls back to OpenLayers instead of waiting.
			dispatch({type: LOAD_OSD_VIEWER_CONFIG, config: {}});
			error_manager("Error loading viewer configuration", error);
		});

export const updateOsdOrganisationConfig = patchBody => dispatch =>
	patch('/api/osd/viewer_config/organisation/', patchBody)
		.then(({organisation}) => dispatch({type: UPDATE_OSD_VIEWER_CONFIG, config: {organisation}}))
		.catch(error => error_manager("Error saving organisation viewer configuration", error));

export const updateOsdUserConfig = patchBody => dispatch =>
	patch('/api/osd/viewer_config/user/', patchBody)
		.then(({user, viewer_configurations}) => {
			dispatch({type: UPDATE_OSD_VIEWER_CONFIG, config: {user}});
			// MorpheusSetting PATCHes send the whole viewer_configurations object, so keep it in sync.
			dispatch({type: UPDATE_MORPHEUS_SETTING, morpheusSetting: {viewer_configurations}});
		})
		.catch(error => error_manager("Error saving viewer preferences", error));

export const setOsdGloballyEnabled = enabled => dispatch =>
	patch('/api/osd/viewer_config/global/', {osd_viewer_enabled: enabled})
		.then(({global}) => dispatch({type: UPDATE_OSD_VIEWER_CONFIG, config: {global}}))
		.catch(error => error_manager("Error saving global viewer switch", error));
